// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__YSO0U","fill":"ProgressBar_fill__6yHnM"};